// Shared shell for legal / docs pages (Terms, Privacy, API Docs). Same brand
// chrome as the app, but a centred prose container and a quiet header.

import { Link } from 'react-router';
import { Plus } from 'lucide-react';
import { Footer } from './Footer';
import { ThemeToggle } from './ThemeToggle';

export function LegalLayout({
  title, lastUpdated, children
}: {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex min-h-screen flex-col">
      <header className="sticky top-0 z-40 border-b border-line bg-canvas/85 backdrop-blur-xl">
        <div className="mx-auto flex max-w-[1400px] items-center gap-3 px-4 py-3 sm:px-6 lg:px-8">
          <Link to="/" className="flex items-center gap-2">
            <img src="/logo.png" alt="PROTBYTE Sentinel" width={28} height={28} draggable={false} />
            <span className="font-display text-lg font-bold tracking-tight text-ink">PROTBYTE <span className="text-accent">Sentinel</span></span>
          </Link>
          <div className="ml-auto flex items-center gap-2">
            <ThemeToggle />
            {/* Bordered + icon style, matching the New Scan / Back-to-app
                pattern used on the results shell and the admin header. */}
            <Link
              to="/"
              aria-label="New scan"
              title="New scan"
              className="inline-flex shrink-0 items-center gap-1.5 rounded-md border border-line-2 bg-panel px-2.5 py-1.5 text-sm font-medium text-ink-2 hover:bg-panel-2 sm:px-3"
            >
              <Plus className="h-4 w-4" strokeWidth={2.25} aria-hidden="true" />
              <span className="hidden sm:inline">New Scan</span>
            </Link>
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-10 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-semibold tracking-[-0.03em] text-ink">{title}</h1>
        <p className="mt-2 text-sm text-ink-3">Last updated: {lastUpdated}</p>
        <div className="legal-prose mt-8">
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
}
